import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import profileComponent from "@/components/user/ProfileComponent.vue";
import favoriteComponent from "@/components/products/FavoriteComponent.vue";
import userOrderList from "@/components/order/UserOrderList.vue";
import CreditNoteListBuyer from "@/components/creditnote/CreditNoteListBuyer.vue";
import walletComponent from "@/components/wallet/WalletComponent.vue";
import { IS_STRIPE_ENABLED } from "@/js/lists.ts";
import { isUserBuyerGroup, isAdminNotConsultant, isConsultantOrHolding, isConsultantNotHolding, isHolding, hasRole } from "@/js/http/auth.js";
import { getMyStatus } from "@/js/user/user_menu.js";
export default {
  name: "userProfile",
  data: function data() {
    return {
      tabs: {},
      selectedTab: null,
      searchCriterias: {
        name: "",
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        label: "",
        vintage: null,
        filters: null
      },
      myStatus: null,
      IS_STRIPE_ENABLED: IS_STRIPE_ENABLED
    };
  },
  components: {
    profile: profileComponent,
    favorite: favoriteComponent,
    orders: userOrderList,
    creditNotes: CreditNoteListBuyer,
    wallet: walletComponent
  },
  props: ["firstConnection", "loggedUserData"],
  watch: {
    $route: function $route() {
      if (this.selectedTab != this.tabs[this.$route.query.tab]) {
        this.changeTab();
      }
    },
    selectedTab: function selectedTab(newVal, oldVal) {
      this.changeTab();
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMyStatus(_this.loggedUserData);
          case 2:
            _this.myStatus = _context.sent;
            if (!!_this.$route.params) {
              if (typeof _this.$route.params.searchCriterias != "undefined") {
                _this.searchCriterias = _this.$route.params.searchCriterias;
              }
              if (isUserBuyerGroup(_this.loggedUserData)) {
                _this.tabs = {
                  profile: "profile",
                  orders: "orders",
                  creditNotes: "creditNotes",
                  favorites: "favorites",
                  wallet: "wallet"
                };
              } else if (isHolding(_this.loggedUserData) && hasRole("manageWallet")) {
                _this.tabs = {
                  profile: "profile",
                  favorites: "favorites",
                  wallet: "wallet"
                };
              } else if (isConsultantOrHolding(_this.loggedUserData)) {
                _this.tabs = {
                  profile: "profile",
                  orders: "orders",
                  creditNotes: "creditNotes",
                  favorites: "favorites",
                  wallet: "wallet"
                };
              } else if (isAdminNotConsultant(_this.loggedUserData)) {
                _this.tabs = {
                  profile: "profile",
                  favorites: "favorites"
                };
              }
              _this.changeTab();
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changeTab: function changeTab() {
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
      } else {
        this.selectedTab = this.tabs.profile;
      }
    },
    isUserBuyerGroup: isUserBuyerGroup,
    isHolding: isHolding,
    isConsultantNotHolding: isConsultantNotHolding,
    isConsultantOrHolding: isConsultantOrHolding,
    hasRole: hasRole
  }
};